module.exports = __webpack_public_path__ + "static/media/person-with-phone-sitting-svgrepo-com.936790c1.svg";